import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import { PlanFeaturesListWrapper } from './planfeatures-list/PlanFeaturesList'

const PlanFeaturesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Plan Features Management',
    path: '/plan-features',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const PlanFeaturesPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/list'
          element={
            <>
              <PageTitle breadcrumbs={PlanFeaturesBreadcrumbs}>Plan Features list</PageTitle>
              <PlanFeaturesListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='list' />} />
    </Routes>
  )
}

export default PlanFeaturesPage
